function accessories_tab() {
  var categories = [
    'view-all',
    'hifi-speakers',
    'wireless-hifi-speakers',
    'headphones',
    'subwoofers'
  ];
  var foreigns = [
    'kef-de.myshopify.com', 'kef-fr.myshopify.com', 'kef-nl.myshopify.com',
    'kef-cn.myshopify.com', 'kef-jp.myshopify.com', 'kef-kr.myshopify.com', 'kef-taiwan.myshopify.com'
  ];
  var trigger_class = '.product-accessories .kef-tabs > ul > li > a';
  var trigger_el = false;
  $(trigger_class).each(function(i) {
    var slug = $(this).attr('href');
    slug = slug.replace('#', '');

    if (window.location.hash == '#'+slug) {
      trigger_el = $(this);
      
      $(this).addClass('active')
        .parent().siblings().find('a').removeClass('active');
    }
  });
  $(document).on('click', trigger_class, function(e) {
    var slug = $(this).attr('href');
    window.location.hash = slug;

    $(this).addClass('active')
      .parent().siblings().find('a').removeClass('active');

    var grid = $('.product-accessories > .row');
    slug = slug.replace('#', '');
    console.log(slug)
    if (slug == 'view-all') {
      $('> div', grid).show();
    } else {
      $('> div', grid).hide();
      $('> div.'+slug, grid).show();
    }

    e.preventDefault();
  });
  if (trigger_el !== false) {
    trigger_el.trigger('click');
  }
}
accessories_tab();